import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginService } from '../../shared/services/login.service';
import { AuthenticatedUser } from '../../shared/models/auth.model';
import { ApplicationFilesService } from '../../shared/services/application-files.service';

@Component({
  selector: 'ins-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss'],
})
export class HeaderNavComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  welcomeLabel = '';
  private userSub: Subscription;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private appFilesService: ApplicationFilesService,
  ) {}

  ngOnInit(): void {
    this.userSub = this.loginService.currentUser$.subscribe(
      (user: AuthenticatedUser | null) => {
        this.isLoggedIn = !!user;
        this.welcomeLabel = user ? `Welcome, ${user.name || user.userName}!` : '';
      },
    );
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  logInOut(): void {
    if (this.isLoggedIn) {
      this.loginService.logout();
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  downloadClaimPacket(): void {
    this.appFilesService.downloadFile('Claim Forms\\Claim Packet.pdf');
  }
}
